import { useMemo } from 'react';

import { useMediaQuery } from '@mui/material';

import type { TTheme } from 'components/Theme/theme';

interface IConfig {
  enforceMobile?: boolean;
  enforceAboveMobile?: boolean;
}

export const useBreakpoints = (config?: IConfig) => {
  const { enforceMobile, enforceAboveMobile } = config || ({} as IConfig);

  const isMobile = useMediaQuery((t: TTheme) => t.breakpoints.only('xs'));
  const isAboveMobile = useMediaQuery((t: TTheme) => t.breakpoints.between('sm', 'md') && t.breakpoints.up('md'));

  return useMemo(() => {
    const result = {
      isMobile: false,
      isAboveMobile: false,
    };

    if (enforceMobile) {
      return { ...result, isMobile: true };
    } else if (enforceAboveMobile) {
      return { ...result, isAboveMobile: true };
    } else {
      return { isMobile, isAboveMobile };
    }
  }, [enforceAboveMobile, enforceMobile, isAboveMobile, isMobile]);
};
